module.exports = {
  ADDRESS_TYPE: {
    PRIMARY: 'PRIMARY',
    PERMANENT: 'PERMANENT',
    BILLING: 'BILLING',
    COMMUNICATION: 'COMMUNICATION'
  },
  ADDRESS_VERIFICATION_REF_TYPE: {
    BERBIX: 'BERBIX',
    DOCUMENT: 'DOCUMENT'
  }
};
